import HadithCommentary from './HadithCommentary';

export { HadithCommentary };
